import { render, staticRenderFns } from "./MailCumulate.vue?vue&type=template&id=6c41b072&scoped=true"
import script from "./MailCumulate.vue?vue&type=script&lang=js"
export * from "./MailCumulate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41b072",
  null
  
)

export default component.exports